@if (productLine ) {
  <div
    class="container quick-order-container"
    [style.display]="(currentView$ | async) === 'products' ? 'block' : 'none'"
  >
    <div class="action-error" *ngIf="showObsoluteMsg">
      <i class="material-icons notification-icon link-anchor">notifications</i>
      <strong>{{ 'quickorder.cannotBeAddedToCart' | cxTranslate }}</strong>
    </div>
    <div class="action-error" *ngIf="showInvalidEntryMsg">
      <i class="material-icons notification-icon link-anchor">notifications</i>
      <strong>{{ 'quickorder.invalidPartCannotBeAdded' | cxTranslate }}</strong>
    </div>
    <div class="action-error" *ngIf="showZeroPriceMsg">
      <i class="material-icons notification-icon link-anchor">notifications</i>
      <strong>{{ 'quickorder.productWithZeroPrice' | cxTranslate }}</strong>
    </div>
    <div class="action-error" *ngIf="emptyConfigId">
      <i class="material-icons notification-icon link-anchor">notifications</i>
      <strong>{{ 'quickorder.emptyConfigId' | cxTranslate }}</strong>
    </div>
    <div class="action-error" *ngIf="showInfoMsg">
      <i class="material-icons notification-icon link-anchor">notifications</i>
      <strong>{{
        messageKey | cxTranslate: { cartType: infoMsgCartTypeText }
      }}</strong>
    </div>

    <div class="quick-order-header">
      <div class="left-side">
        <div class="order-text">
          {{ 'quickorder.quickorder' | cxTranslate }}
        </div>
        <div class="order-side-text" *ngIf="!textChange">
          {{ 'quickorder.convertProdIntoOrder' | cxTranslate }}
        </div>
        <div class="order-side-text" *ngIf="textChange">
          {{ 'quickorder.transformListIntoOrder' | cxTranslate }}
        </div>
      </div>
      <div class="right-side">
        @if (isShowSaveCartBtn) {
          <div class="waygate-cart-action-option">
            <a
              class="action-links mr-4"
              (click)="openSaveCartModal('large-device')"
            >
              <bh-button
                type="secondary"
                class="waygate-cart-action-option-text"
                label="{{ 'buyCart.savecart' | cxTranslate }}"
                [leftIcon]="'save'"
              ></bh-button>
            </a>
          </div>
        }
        <div class="addtocart">
          <div class="add-button track-button">
            <bh-button
              type="primary"
              label="{{ 'quickorder.addToCart' | cxTranslate }}"
              class="add-cart"
              (click)="addToCart()"
              [class.add-button-disabled]="
                !enableAddToCart || (showLoader$ | async)
              "
              [attr.loading]="(showLoader$ | async) ? true : null"
            ></bh-button>
          </div>
        </div>
      </div>
    </div>
    <div class="quick-order-body">
      <app-order-parts
        (dataEmitter)="handleData($event)"
        (partsCopied)="partsCopied($event)"
        (deleteRow)="deleteRow($event)"
      ></app-order-parts>
      <app-quick-order-products
        [sharedData]="sharedData"
        (enableAddToCart)="enableCart($event)"
        [deletedRow]="deletedRow"
        (disableAddToCart)="disableAddToCart($event)"
        (bulkUploadSelection)="onBulkUploadSelection($event)"
        (bulkUploadValidatedList)="onValidatedProductsList($event)"
        (infoMsg)="onInfoMsg($event)"
        [refreshSelection]="refreshSelection"
      ></app-quick-order-products>
    </div>
    <div>
      <p class="explore-prods-nav-link">
        {{ 'quickorder.dontHaveSpecPartNumbers' | cxTranslate }}
        <a [href]="allProductsUrl" (click)="goToProductCatalogue()">
          {{ 'quickorder.exploreAllProducts' | cxTranslate }}</a
        >
        <span class="material-icons explore-prods-arrow">north_east</span>
      </p>
    </div>
  </div>
  @if ((currentView$ | async) === 'address') {
    <app-waygate-quick-order-address
      [bulkUploadSelection]="bulkUploadSelection"
      [validatedProductsList]="validatedProductsList"
      (submitWithEca)="onSubmitWithEca()"
    >
    </app-waygate-quick-order-address>
  }
} @else {
  <div class="container quick-order-blocked-container">
    <bh-illustration
      source="Broom"
      title="We are upgrading!"
      description="This page is being updated and will be restored soon."
    ></bh-illustration>
  </div>
}
